import React from 'react';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton
} from "react-accessible-accordion";

const FAQPageAccordion = () => {

  return (
    <Accordion preExpanded={[1]} key="becomeAHostPageFAQ" allowZeroExpanded >
      <AccordionItem uuid={1}>
        <AccordionItemHeading>
          <AccordionItemButton>
            What is AllCourse and how does it work?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            AllCourse is a marketplace linking schools with credentialed teachers offering for-credit courses.
            Schools using AllCourse can reduce staffing pressures while significantly increasing their course catalog.
          </p>
          <p>
            Teachers create profiles detailing their professional experience, and then create listings of courses they’d like to teach.
          </p>
          <p>
            Teacher profiles and courses are easy for school administrators to browse or search. Admins can offer online teaching positions
            to teachers they connect with. Schools can buy one seat, the entire class, or anything in between. AllCourse manages the matching,
            the messaging, and the financial transaction.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={2}>
        <AccordionItemHeading>
          <AccordionItemButton>
            Do teachers have to be licensed to teach through AllCourse?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Not necessarily. Private and charter school teachers often don’t have licenses to teach in public schools.
            AllCourse is open to all qualified teachers, including private and charter school teachers.
          </p>
          <p>
            Teachers who don’t provide a license number will not show up in search results for public schools.
            They may still show up in search results for private or charter schools.
          </p>
          <p>
            Public school teachers should add their license number to their profile, to ensure that they show up
            in searches for online teaching opportunities with public schools.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={3}>
        <AccordionItemHeading>
          <AccordionItemButton>
            What is the main idea behind AllCourse?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            There is currently a teacher shortage in many parts of the U.S., making it harder to staff schools, which is tough
            for administrators and bad for students. It also creates additional work and stress for teachers, who are asked to do ever more.
          </p>
          <p>
            AllCourse makes it much easier to match great teachers with schools. Teachers can earn extra money (they deserve it).
            And admins can solve their staffing problems and offer students and parents a much larger course catalog.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={4}>
        <AccordionItemHeading>
          <AccordionItemButton>
            Is AllCourse a place for admins to buy individual seats in online courses, or a place to hire teachers
            who will teach online classes just for their school?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Schools can do either or both.
          </p>
          <p>
            If admins need someone to teach an entire section, they can search profiles for a teacher who best meets their particular
            needs and work with that teacher to schedule a course specifically for their school. The teacher will create a customized course
            listing and the admin will buy all of the seats.
          </p>
          <p>
            In many cases, schools won’t require every seat in a particular course. But they might want to buy a few seats
            in order to satisfy interested students and parents. Using AllCourse, schools can offer online courses in just
            about every subject, or with a particular pedagogical focus such as micro class size or remedial/advanced material.
            When buying just a small number of seats in a course, there will likely be students from other schools participating.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={5}>
        <AccordionItemHeading>
          <AccordionItemButton>
            Do class sessions take place on AllCourse?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            For now, no. Teachers will post class invitations and requirements in their course listings.
            They will describe which video platform and homework solutions they want to use. School admins can and should contact
            teachers before the first class to discuss their needs and expectations.
          </p>
          <p>
            Over time, AllCourse will add capabilities to allow more of the classroom experience
            to take place on AllCourse for those who would prefer that.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={6}>
        <AccordionItemHeading>
          <AccordionItemButton>
            Is AllCourse an accredited institution?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            No. AllCourse is not a school. AllCourse is a marketplace. We offer a service linking
            schools and credentialed teachers offering for-credit courses.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={7}>
        <AccordionItemHeading>
          <AccordionItemButton>
            How does course accreditation work?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            In their profiles, teachers list all the places where they are licensed to teach. If a course is not
            currently approved for credit in a given region, the administrator purchasing it will have to gain approval
            to give it credit. Admins can often avoid this problem by choosing teachers who have previously taught that
            course in their state/district — chances are it’s already approved for credit.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={8}>
        <AccordionItemHeading>
          <AccordionItemButton>
            How is AllCourse different from companies that sell courses to school districts?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Some companies create their own courses, hire their own teachers, and sell directly to school districts. It’s
            expensive to create and sell a course; it requires subject matter experts, instructional designers, content
            creators, teachers, salespeople, tech staff, and other overhead. Even then, the resulting course is aligned to
            the standards of just one state or a small number of states. Because courses are so expensive for these companies
            to build and maintain, they don’t offer a very wide range of subjects, or much choice in teachers.
          </p>
          <p>
            AllCourse is different. We’re a marketplace that allows schools to purchase seats in courses
            directly from the expert teachers who create and teach them.
          </p>
          <p>
            For teachers, the advantages of AllCourse are flexibility and income.
          </p>
          <ul>
            <li>
              You're your own boss, not an employee of some big company that keeps most of the profits.
            </li>
            <li>
              You can set your own schedule and rates.
            </li>
            <li>
              You can reach a wider audience.
            </li>
          </ul>
          <p>
            For schools, the advantages of AllCourse are savings, flexibility, and far greater choice in subject matter and teacher.
          </p>
          <ul>
            <li>
              Find exactly what you need, whenever you need it. Pay for only what you use. Start and stop using the platform whenever you want.
            </li>
            <li>
              85% of what you pay goes to teachers and/or other schools.
            </li>
            <li>
              There is no limit to the subject matter you can find on AllCourse, or the teacher styles, class sizes, or pedagogical approaches.
            </li>
            <li>
              If for some reason the first teacher you chose doesn’t work out, you can switch your students into another teacher’s course, often at no additional cost.
            </li>
          </ul>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={9}>
        <AccordionItemHeading>
          <AccordionItemButton>
            What type of technology do I need to use AllCourse?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            AllCourse works on all major web browsers.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={10}>
        <AccordionItemHeading>
          <AccordionItemButton>
            What format do the classes take?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Classes are online. Teachers choose the video platform they’re most comfortable delivering classes
            in (e.g., Zoom, Google Hangout) and let students know when to log in. Teachers also inform students what
            homework materials or classroom management tools (e.g., Google Classroom) will be used.
          </p>
        </AccordionItemPanel>
      </AccordionItem>

      <AccordionItem uuid={11}>
        <AccordionItemHeading>
          <AccordionItemButton>
            How can I contact customer support?
          </AccordionItemButton>
        </AccordionItemHeading>
        <AccordionItemPanel>
          <p>
            Email <a href="mailto:support@allcourse.com">support@allcourse.com</a>
          </p>
        </AccordionItemPanel>
      </AccordionItem>

    </Accordion>
  );
};

export default FAQPageAccordion;
